import * as _ from 'lodash'; //{ isString, isNumber, isArray, includes, isDate }s
//import { WithId } from './Buckets';

const doseTypes = {
  'number': undefined,
  'volume': undefined,
  '': undefined,
  'undefined': undefined,
  'null': undefined,
};
const medicineAppearances = {
  'application': undefined,
  'bandage': undefined,
  'bar': undefined,
  'block': undefined,
  'capsule': undefined,
  'collodion': undefined,
  'conditioner': undefined,
  'cream': undefined,
  'diluent': undefined,
  'dressing': undefined,
  'drug delivery system': undefined,
  'ear drops': undefined,
  'ear ointment': undefined,
  'enema': undefined,
  'eye and ear': undefined,
  'eye drops': undefined,
  'eye gel': undefined,
  'eye ointment': undefined,
  'eye pad': undefined,
  'eye solution': undefined,
  'eye spray': undefined,
  'eye strip': undefined,
  'film': undefined,
  'foam': undefined,
  'foam dressing': undefined,
  'gas': undefined,
  'gel': undefined,
  'glove': undefined,
  'granules': undefined,
  'gum': undefined,
  'implant': undefined,
  'inhalation': undefined,
  'injection': undefined,
  'intratracheal suspension': undefined,
  'jelly': undefined,
  'liniment': undefined,
  'liquid': undefined,
  'lotion': undefined,
  'lozenge': undefined,
  'mouthwash': undefined,
  'nasal cream': undefined,
  'nasal drops': undefined,
  'nasal gel': undefined,
  'nasal ointment': undefined,
  'nasal spray': undefined,
  'oil': undefined,
  'ointment': undefined,
  'oral gel': undefined,
  'oral liquid': undefined,
  'oral semi-solid': undefined,
  'oral spray': undefined,
  'pad': undefined,
  'paint': undefined,
  'paste': undefined,
  'pastille': undefined,
  'patch': undefined,
  'pessary': undefined,
  'powder': undefined,
  'ribbon': undefined,
  'roll': undefined,
  'rope': undefined,
  'shampoo': undefined,
  'sheet': undefined,
  'solution': undefined,
  'spray': undefined,
  'stick': undefined,
  'strip': undefined,
  'suppository': undefined,
  'tablet': undefined,
  'tape': undefined,
  'tincture': undefined,
  'toothpaste': undefined,
  'vaginal cream': undefined,
  'vaginal gel': undefined,
  'wafer': undefined
};
const scheduleTypes = {
  everyday: undefined,
  specific: undefined,
  interval: undefined,
  needed: undefined
};
const scheduleDays = {
  mon: undefined,
  tue: undefined,
  wed: undefined,
  thu: undefined,
  fri: undefined,
  sat: undefined,
  sun: undefined
};

const statusCodes = {
  active: undefined,
  completed: undefined,
  entered_in_error: undefined,
  intended: undefined,
  stopped: undefined,
  on_hold: undefined,
};
const takenCodes = {
  y: undefined,
  n: undefined,
  unk: undefined,
  na: undefined,
};

export const DAYS_ORDER: ScheduleDay[] = [
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat'
];

export const FORM_FIELD_NAMES = {
  display: 'Medicine',
  frequency: 'Frequency',
  interval: 'How often?',
  days: 'Which days?',
  occurrenceCount: 'How many times a day?',
  occurrenceTime: 'What time?',
  quantity: 'Quantity',
  volume: 'Volume'
};

export const SCHEDULE_TYPE_NAMES: { [V in ScheduleType]: string } = {
  everyday: 'Everyday',
  specific: 'Specific Days',
  interval: 'Days with an Interval',
  needed: 'As needed'
};

export const OCCURRENCE_COUNT_NAMES: { [V: number]: string } = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6 (Every 4 hours)',
  7: '7',
  8: '8 (Every 3 hours)',
  9: '9',
  10: '10',
  11: '11',
  12: '12 (Every 2 hours)',
  24: '24 (Every 1 hour)'
};

export const DAY_NAMES: { [V in ScheduleDay]: string } = {
  sun: 'Sunday',
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday'
};

export type DoseType = keyof typeof doseTypes;
export type MedicineAppearance = keyof typeof medicineAppearances;
export type ScheduleType = keyof typeof scheduleTypes;
export type ScheduleDay = keyof typeof scheduleDays;
export type Status = keyof typeof statusCodes;
export type Taken = keyof typeof takenCodes;

export type MedicineDailyOccurrenceOption =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 24;
export const medicineDailyOccurrenceOptions: MedicineDailyOccurrenceOption[] = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  24
];

export type MedicineIntervalOption =
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29;
export const MIN_INTERVAL: MedicineIntervalOption = 2;
export const MAX_INTERVAL: MedicineIntervalOption = 29;

export interface MedicineSearchResult {
  id: string;
  displayName: string;
  displayNameVerbose?: string;
  appearance: MedicineAppearance;
  doseType: DoseType;
}

export interface MedicineOccurrence {
  time?: string; // 24 hr HH:MM
  dose?: number;
}

export interface ISchedule {
  type: ScheduleType;
  occurrences?: MedicineOccurrence[];
}

export interface ScheduleEveryday extends ISchedule {
  type: 'everyday';
  perDay: MedicineDailyOccurrenceOption;
}

export interface ScheduleSpecific extends ISchedule {
  type: 'specific';
  perDay: MedicineDailyOccurrenceOption;
  days: ScheduleDay[];
}

export interface ScheduleInterval extends ISchedule {
  type: 'interval';
  interval: MedicineIntervalOption;
  started: Date;
}

export interface ScheduleAsNeeded extends ISchedule {
  type: 'needed';
}

export type Schedule =
  | ScheduleEveryday
  | ScheduleSpecific
  | ScheduleInterval
  | ScheduleAsNeeded;

/*export interface MedicineRecord extends MedicineSearchResult, WithId {
  schedule: Schedule;
  started: Date;
  end?: Date;
  priorPrescription?: string;
  deletedAt?: Date | string; // to allow for empty ""
}*/

/*export interface MedicineScheduleRecord extends WithId {
  date: Date;
  deletedAt?: Date | string; // to allow for empty ""
}*/

export const STATUS_CODES: { [V in Status]: string } = {
  active: 'active',
  completed: 'completed',
  entered_in_error: 'entered-in-error',
  intended: 'intended',
  stopped: 'stopped',
  on_hold: 'on-hold'
};
export enum TAKEN_CODES {
  y = 'y',
  n = 'n',
  unk = 'unk',
  na = 'na',
}

/*export interface MedicationFHIR {
  medicationReference: MedicineRecord;
  medicationCodableConcept?: any;
}*/

export interface EffectiveFHIR {
  effectiveDateTime: any;
  effectivePeriod?: any;
}
// https://www.hl7.org/fhir/medicationstatement.html

/*export interface MedicineStatementRecord extends WithId {
  scheduleId: string;
  scheduleDate: Date;
  medicineId: string;
  medication: MedicationFHIR;
  status: Status;
  taken: Taken;
  reasonNotTaken: any;
  reasonCode?: any;
  dateAsserted: Date;
  informationSource?: any;
  subject?: any;
  derivedFrom?: any;
  dosage: MedicineOccurrence;
  note?: string;
  identifier?: any;
  basedOn?: any;
  partOf?: any;
  context?: any;
  category?: any;
  reasonReference?: any;
  takenAt?: Date;
  skippedAt?: Date;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  isSkipped?: boolean;
  effective?: EffectiveFHIR;
}*/

export function isDoseType(test: any): test is DoseType {
  return doseTypes.hasOwnProperty(test);
}

export function isMedicineAppearance(test: any): test is MedicineAppearance {
  return medicineAppearances.hasOwnProperty(test);
}

export function isScheduleType(test: any): test is ScheduleType {
  return scheduleTypes.hasOwnProperty(test);
}

export function isScheduleDay(test: any): test is ScheduleDay {
  return scheduleDays.hasOwnProperty(test);
}

export function isMedicineDailyOccurrenceOption(
  test: any
): test is MedicineDailyOccurrenceOption {
  return _.isNumber(test) && _.includes(medicineDailyOccurrenceOptions, test);
}

export function isMedicineIntervalOption(
  test: any
): test is MedicineIntervalOption {
  return _.isNumber(test) && test >= MIN_INTERVAL && test <= MAX_INTERVAL;
}

export function isMedicineSearchResult(
  test: any
): test is MedicineSearchResult {
  return (
    test &&
    _.isString(test.id) &&
    _.isString(test.displayName) &&
    // isDoseType(test.doseType) &&
    isMedicineAppearance(test.appearance)
  );
}

export function isMedicineOccurrence(test: any): test is MedicineOccurrence {
  return test && _.isString(test.time) && _.isNumber(test.dose) && test.dose > 0;
}

export function isScheduleEveryday(test: any): test is ScheduleEveryday {
  return (
    test &&
    test.type === 'everyday' &&
    isMedicineDailyOccurrenceOption(test.perDay) &&
    _.isArray(test.occurrences) &&
    test.occurrences.every(isMedicineOccurrence)
  );
}

export function isScheduleSpecific(test: any): test is ScheduleSpecific {
  return (
    test &&
    test.type === 'specific' &&
    isMedicineDailyOccurrenceOption(test.perDay) &&
    _.isArray(test.days) &&
    test.days.every(isScheduleDay) &&
    _.isArray(test.occurrences) &&
    test.occurrences.every(isMedicineOccurrence)
  );
}

export function isScheduleInterval(test: any): test is ScheduleInterval {
  return (
    test &&
    test.type === 'interval' &&
    isMedicineIntervalOption(test.interval) &&
    _.isArray(test.occurrences) &&
    test.occurrences.every(isMedicineOccurrence)
  );
}

export function isScheduleAsNeeded(test: any): test is ScheduleAsNeeded {
  return test && test.type === 'needed';
}

export function isSchedule(test: any): test is Schedule {
  return (
    isScheduleEveryday(test) ||
    isScheduleSpecific(test) ||
    isScheduleInterval(test) ||
    isScheduleAsNeeded(test)
  );
}

/*export function isMedicineRecord(test: any): test is MedicineRecord {
  return (
    test &&
    isString(test.id) &&
    isString(test.displayName) &&
    isMedicineAppearance(test.appearance) &&
    // isDoseType(test.doseType) &&
    isSchedule(test.schedule) &&
    isDate(test.started)
  );
}*/

/*export function isForToday(day: moment.Moment, medicine: MedicineRecord, statements?: { [time: string]: MedicineStatementRecord }) {
  const sinceStarted = moment(medicine.started).startOf('day').diff(day, 'days');

  const schedule: Schedule = medicine.schedule;
  let hasScheduleToday: Boolean = false;
  if (isScheduleSpecific(schedule)) {
    const specificSchedule: ScheduleSpecific = schedule;
    const daysSpecified: Array<string> = specificSchedule.days;
    hasScheduleToday = daysSpecified.indexOf(moment(day).format('ddd').toLowerCase()) >= 0;
  } else if (isScheduleInterval(schedule)) {
    const intervalSchedule: ScheduleInterval = schedule;
    hasScheduleToday = moment().startOf('day').add(sinceStarted, 'days').diff(moment(medicine.started).startOf('day'), 'days') % intervalSchedule.interval === 0;
  } else if (!isScheduleAsNeeded(schedule)) {
    hasScheduleToday = true;
  }

  if (medicine.deletedAt) {
    // a medicine deleted today is valid only if there is already statements
    const deletedMoment = moment(medicine.deletedAt);
    if (deletedMoment.isBefore(day.startOf('day'))) {
      hasScheduleToday = false;
    } else if (deletedMoment.isSame('day')) {
      // it was deleted today. If there is a statement for today, it is valid
      if (hasScheduleToday && !statements) {
        hasScheduleToday = false;
      }
    }
  }

  return hasScheduleToday;
}*/
